export const iconFontAwesomeTransportationVanShuttle = (
	<i className="fa-solid fa-van-shuttle"></i>
);
